/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const CreateSSOProviderDataParser = 
/* #__PURE__ */ parsers.object([
    ['metadataUrl', codecString, 'metadata_url'],
    ['description', codecString],
    ['tenantId', codecString, 'tenant_id'],
]);
export class CreateSSOProviderData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return CreateSSOProviderDataParser.decode(input).map(res => new CreateSSOProviderData(res));
    }
    static unsafeDecode(input) {
        return CreateSSOProviderData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return CreateSSOProviderDataParser.encode(data);
    }
    static schema() {
        return CreateSSOProviderDataParser.schema();
    }
}
